import { Injectable } from "@angular/core";
import { Router, NavigationExtras } from "@angular/router";

@Injectable()
export class NavigationService {
	constructor(
		private router: Router
	) { }

	public navigate(commands: any[], extras?: NavigationExtras) {
		/*
		we need to handle error cases for navigation attempts
		we'll just assume that we need to show them a landing page instead of wherever they were going
		*/
		this.router.navigate(commands, extras)
			.then((result) => {
				/*
				Only navigate to the error page when the result is false.
				If the result is null there was an attempt to navigate to the current route which is ignorable.
				*/
				// tslint:disable-next-line:no-boolean-literal-compare
				if (result === false) {
					this.goToNavigationErrorPage();
				}
			})
			.catch((e) => {
				this.goToNavigationErrorPage();
			});
	}

	private goToNavigationErrorPage() {
		/*
		this is the case where we are responding to a previous navigation error
		if navigation keeps failing just ignore these errors
		*/
		this.router.navigate(["/login/login"])
			.then((result) => {
				// navigation has already failed, we can't possibly keep trying here
			})
			.catch((e) => {
				// navigation has already failed, we can't possibly keep trying here
			});
	}
}
